import { render, staticRenderFns } from "./PostCodesMapTile.vue?vue&type=template&id=744db0fa&"
import script from "./PostCodesMapTile.vue?vue&type=script&lang=ts&"
export * from "./PostCodesMapTile.vue?vue&type=script&lang=ts&"
import style0 from "./PostCodesMapTile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports